import { Box, Header as UCHeader, Text as UCText, VStack } from '@rbilabs/universal-components';

export const Container = Box.withConfig({
  paddingX: '$4',
  paddingY: '$9',
});

export const Body = VStack.withConfig({
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '$4',
});

export const Header = UCHeader.withConfig({
  margin: '$0',
  fontSize: '2xl',
  textAlign: 'center',
  lineHeight: 'lg',
});

export const Text = UCText.withConfig({
  textAlign: 'center',
  marginTop: '$4',
});
